/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FormQuestionType {
  YesNo = 'YesNo',
  Multiline = 'Multiline',
  MultiChoice = 'MultiChoice',
  SingleChoiceRadio = 'SingleChoiceRadio',
  SingleChoiceSelect = 'SingleChoiceSelect'
}
